<template>
  <div>
    <div class="title">
      <span class="navigation">{{$route.meta.title}}</span>
      <span class="icon" @click="search">
        <i class="iconfont icon-sousuo1"></i>
      </span>
    </div>
    <div class="content">
      <ul>
        <li v-for="item in folderList" :key="item.id" class="folder-item">
          <div class="folder-title">
            <span class="folder-name">{{item.name}}</span>
            <span class="all" @click="LookAllModel(item)">全部</span>
          </div>
          <ul class="model-wrapper">
            <li
              v-for="option in allModel[item.id]"
              :key="option.id"
              class="model-item"
              @click="BrowseModel(option)"
            >
              <img :src="option.thumbnail | thumbnailGem(340,340)">
              <div class="model-name">{{option.name}}</div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { folderList, modelList } from "@/api/modelReq";
import { Toast } from "vant";
export default {
  data() {
    return {
      folderList: [],
      allModel: {}
    };
  },
  created() {
    folderList().then(res => {
      this.folderList = res;
      res.forEach(element => {
        modelList({ page: 1, pageSize: 4, categoryId: element.id }).then(
          result => {
            this.$set(this.allModel, element.id, result.list);
          }
        );
      });
    });
  },
  methods: {
    // search
    search() {
      this.$router.push({
        path: "/search",
        query: {
          category: "gem"
        }
      });
    },
    BrowseModel(item) {
      if (item.isAlbum) {
        // type : vertical为竖向，transverse为横向
        // this.$store.dispatch("ChangePreviewShow", {
        //   item,
        //   show: true,
        //   type: "vertical"
        // });
        this.$router.push(`/preview-album/${item.id}`)
        return;
      }
      // if (!item.modelId) {
      //   Toast("没有上传模型");
      //   return;
      // }
      this.$router.push({
        path: `/model-view/${item.id}`
      });
    },
    LookAllModel(item) {
      this.$router.push({
        path: "/all-model",
        query: {
          id: item.id,
          name: item.name
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
// 注释为备份
.title {
  position: relative;
  height: 60px;
  .navigation {
    position: absolute;
    top: 20px;
    left: 15px;
    font-size: 24px;
    font-weight: 800;
    color: rgba(51, 51, 51, 1);
  }
  .icon {
    position: absolute;
    top: 30px;
    right: 15px;
    font-size: 20px;
  }
}
.content {
  margin-top: 40px;
  padding: 0 14px;
  .folder-item {
    margin-bottom: 40px;
    .folder-title {
      .folder-name {
        // border-left: 3px solid rgba(119,97,207,1);
        position: relative;
        padding-left: 10px;
        // border-image:linear-gradient(0deg,rgba(119,97,207,1) 0%,rgba(80,89,188,1) 100%);
        font-size: 18px;
        font-weight: 800;
        color: rgba(51, 51, 51, 1);
        &::after {
          position: absolute;
          content: "";
          left: 0;
          top: 21%;
          width: 3px;
          height: 17px;
          background: rgba(119, 97, 207, 1);
        }
      }
      .all {
        float: right;
        display: inline-block;
        width: 50px;
        height: 23px;
        line-height: 23px;
        font-size: 12px;
        text-align: center;
        color: rgba(0, 0, 0, 0.5);
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 13px;
      }
    }
    .model-wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      // justify-content: center;
      justify-content: space-between;
      flex-wrap: wrap;
      align-items: center;
      margin-top: 20px;
      .model-item {
        width: 49%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 13px;
        text-align: center;
        background: rgba(255, 255, 255, 1);
        box-shadow: 2px 3px 6px 0px rgba(66, 83, 103, 0.05);
        border-radius: 2px;
        img {
          width: 100%;
          height: 45.34vw;
          vertical-align: middle;
        }
        .model-name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100%;
          text-align: left;
          color: rgba(51, 51, 51, 1);
          font-size: 14px;
          font-weight: 400;
          padding: 8% 0 7% 9%;
          box-sizing: border-box;
        }
      }
    }
  }
  .folder-item:last-child {
    margin-bottom: 66px;
  }
}
</style>